import React from 'react';
import '../css/Footer.css';
import email from '../img/email.svg';
import instagram from '../img/instagram.svg';
import github from '../img/github.svg';
import linkedin from '../img/linkedin.svg';


function Footer() {
    return (
        <div className="footer">
            <div className="footer__center">
                <div className="img1">
                    <a href="mailto:ilir.shala111@gmail.com" target="_blank">
                        <img src={email} alt="" />
                    </a>

                </div>
                <div className="img1">
                    <a href="https://www.instagram.com/ilirshala7/" target="_blank">
                        <img src={instagram} alt="" />
                    </a>
                </div>
                <div className="img1">
                    <a href="https://github.com/ilirshala" target="_blank">
                        <img src={github} alt="" />
                    </a>
                </div>
                <div className="img1">
                <a href="https://www.linkedin.com/in/ilir-shala-4077aa1ab/" target="_blank">
                        <img src={linkedin} alt="" />
                    </a>
                </div>
            </div>
            <div className="footer__title">
                <h1 style={{textAlign: 'center'}}>© Ilir Shala 2021 </h1>
            </div>
        </div>
    )
}

export default Footer
